import React from "react";
import Button from "../Buttons/Button";
import { buttonNameConstants, buttonTypeConstants } from "../../../constants";
import { Col } from "react-bootstrap";

const ModalActionButtons = ({
  handleCloseModal,
  cancelButtonLabel = buttonNameConstants.CANCEL,
  submitButtonLabel = buttonNameConstants.ADD,
  className,
}) => {
  return (
    <Col md={12} className={`m-0 d-flex gap-2 ${className}`}>
      <Button
        type="button"
        label={cancelButtonLabel}
        handleClick={handleCloseModal}
        buttonType={buttonTypeConstants.GHOST_BUTTON}
        className="w-100"
      />
      <Button
        type="submit"
        label={submitButtonLabel}
        buttonType={buttonTypeConstants.PRIMARY_BUTTON}
        className="w-100"
      />
    </Col>
  );
};

export default ModalActionButtons;
